/** Layout state for the finding-detail split view (INP-520): the finding
 *  card and the invoice sit side by side, and either can be expanded to fill
 *  the width (hiding the other). Pure so the class + visibility logic is
 *  unit-tested without the route. */
export type SplitExpand = 'split' | 'finding' | 'invoice';

/** Grid container class: two columns when balanced, one column (full width)
 *  when a panel is expanded. Below `lg` it always stacks. */
export function splitContainerClass(expanded: SplitExpand): string {
  return expanded === 'split'
    ? 'grid gap-4 lg:grid-cols-2 lg:items-start'
    : 'grid gap-4';
}

/** The finding panel is shown unless the invoice is the expanded one. */
export function showsFinding(expanded: SplitExpand): boolean {
  return expanded !== 'invoice';
}

/** The invoice panel is shown unless the finding is the expanded one. */
export function showsInvoice(expanded: SplitExpand): boolean {
  return expanded !== 'finding';
}

/** Toggle a panel: expand it if not already expanded, else restore the
 *  balanced split. */
export function togglePanel(current: SplitExpand, panel: 'finding' | 'invoice'): SplitExpand {
  return current === panel ? 'split' : panel;
}
